<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Nilai Project Management">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="total_proposal" slot-scope="record">
                    <center>{{ record.scorer.total_proposal }}</center>
                </div>

                <div slot="total_presentasi" slot-scope="record">
                    <center>{{ record.scorer.total_presentasi }}</center>
                </div>

                <div slot="total_implementasi" slot-scope="record">
                    <center>{{ record.scorer.total_implementasi }}</center>
                </div>

                <div slot="total_followup" slot-scope="record">
                    <center>{{ record.scorer.total_followup }}</center>
                </div>

                <div slot="total_evaluasi" slot-scope="record">
                    <center>{{ record.scorer.total_evaluasi }}</center>
                </div>

                <div slot="final_score" slot-scope="record">
                    <center>{{ record.scorer.final_score }}</center>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'total',
            title: 'Total Nilai',
            scopedSlots: {customRender: 'total'},
            children: [
                {
                    key: 'total_proposal',
                    title: 'Proposal 20%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_proposal'},
                },
                {
                    key: 'total_presentasi',
                    title: 'Presentasi 10%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_presentasi'},
                },
                {
                    key: 'total_implementasi',
                    title: 'Implementasi 20%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_implementasi'},
                },
                {
                    key: 'total_followup',
                    title: 'Follow Up 40%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_followup'},
                },
                {
                    key: 'total_evaluasi',
                    title: 'Evaluasi 10%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_evaluasi'},
                },
            ]
        },
        {
            key: 'final_score',
            title: 'Nilai Akhir',
            align: 'center',
            scopedSlots: {customRender: 'final_score'}
        }
    ]

    export default {
        data() {
            return {
                columns,
                items: [],
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems(){
                let params = {
                    user_hash: this.$laravel.user.hash,
                    recap_type: 'attendant'
                }

                this.loading = true

                this.$http
                    .get(this.routeUri('api.recap.activity-score.attendants_result')+ '?' + this.$qs.stringify(params))
                    .then(response => this.items = response.data.attendants)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            },
        },
        computed: {
            tableData(){
                if(this.items.length > 0){
                    let idx = 0
                    let collection = []
                    let scorer = {}
                    let idx2 = 0
                    let idxprjpro = 0
                    let idxprjpre = 0
                    let idxprjimp = 0
                    let idxprjfou = 0
                    let idxprjeva = 0
                    let totProposal = 0
                    let totPresentasi = 0
                    let totImplementasi = 0
                    let totFollowup = 0
                    let totEvaluasi = 0

                    this.items.forEach(function(item){
                        idx++
                        item.evaluators.forEach(function(evaluator){
                            let scoreEvaluator = item.activities[0].evaluator_score[evaluator]
                            if(Array.isArray(scoreEvaluator)){
                                idx2++
                                scoreEvaluator.forEach(function(score){
                                    if(score.scoreable.scoreable_type === 'aspect'){
                                        if(score.scoreable.code === 'PRJ-PRO'){
                                            totProposal = parseFloat(totProposal) + parseFloat(score.score)
                                            idxprjpro++
                                        }else if(score.scoreable.code === 'PRJ-PRE'){
                                            totPresentasi = parseFloat(totPresentasi) + parseFloat(score.score)
                                            idxprjpre++
                                        }else if(score.scoreable.code === 'PRJ-IMP'){
                                            totImplementasi = parseFloat(totImplementasi) + parseFloat(score.score)
                                            idxprjimp++
                                        }else if(score.scoreable.code === 'PRJ-FOU'){
                                            totFollowup = parseFloat(totFollowup) + parseFloat(score.score)
                                            idxprjfou++
                                        }else if(score.scoreable.code === 'PRJ-EVA'){
                                            totEvaluasi = parseFloat(totEvaluasi) + parseFloat(score.score)
                                            idxprjeva++
                                        }
                                    }
                                })
                            }
                        })

                        let proposal = totProposal == 0 ? 0 : totProposal / idxprjpro
                        let presentasi = totPresentasi == 0 ? 0 : totPresentasi / idxprjpre
                        let implementasi = totImplementasi == 0 ? 0 : totImplementasi / idxprjimp
                        let followup = totFollowup == 0 ? 0 : totFollowup / idxprjfou
                        let evaluasi = totEvaluasi == 0 ? 0 : totEvaluasi / idxprjeva

                        scorer['total_proposal'] = parseFloat(proposal).toFixed(2)
                        scorer['total_presentasi'] = parseFloat(presentasi).toFixed(2)
                        scorer['total_implementasi'] = parseFloat(implementasi).toFixed(2)
                        scorer['total_followup'] = parseFloat(followup).toFixed(2)
                        scorer['total_evaluasi'] = parseFloat(evaluasi).toFixed(2)

                        scorer['final_score'] = parseFloat(proposal + presentasi + implementasi + followup + evaluasi).toFixed(2)
                        collection.push({
                            id: idx,
                            scorer
                        })
                    })

                    return collection
                }

                return []
            }
        },
    }
</script>
